var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopUpTitleImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24px/Chatbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1031 6.18898C17.7307 5.53287 17.7307 4.4691 17.1031 3.81299C16.4756 3.15688 15.458 3.15688 14.8305 3.81299L12.3017 6.45669C11.6741 7.1128 11.6741 8.17657 12.3017 8.83268C12.9293 9.48879 13.9468 9.48879 14.5744 8.83268L17.1031 6.18898Z",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3129 13.2881C10.9404 12.632 10.9404 11.5682 10.3129 10.9121C9.68527 10.256 8.66776 10.256 8.04017 10.9121L5.51142 13.5558C4.88383 14.2119 4.88383 15.2757 5.51142 15.9318C6.139 16.5879 7.15651 16.5879 7.7841 15.9318L10.3129 13.2881Z",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.125 7.875L9.625 11.375",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopUpTitleImg);
export default __webpack_public_path__ + "static/media/pop-up-title-img.e00acea06bee3ea99485f10007d3d8ab.svg";
export { ForwardRef as ReactComponent };